import { WIZARD } from "../../constants/action-types";

const initialState = {
  campaignId: null,
  audienceId: null,
  complexAudienceId: null,
  designId: null,
  oldDesignId: null
};

const WizardReducer = (state = initialState, action) => {
  switch (action.type) {
    case WIZARD.UPDATE_CAMPAIGN_ID: {
      return Object.assign({}, state, {
        campaignId: action.payload,
      });
    }
    case WIZARD.UPDATE_AUDIENCE_ID: {
      return Object.assign({}, state, {
        audienceId: action.payload.audienceId,
        complexAudienceId: action.payload.complexAudienceId,
      });
    }
    case WIZARD.UPDATE_DESIGN_ID: {
      return Object.assign({}, state, {
        designId: action.payload,

      });
    }
    case WIZARD.CLEAR_ALL_WIZARD: {
      return initialState;
    }
    case WIZARD.UPDATE_CAMPAIGN_AUDIENCE_DESIGN: {
      return Object.assign({}, state, {
        campaignId: action.payload.campaignId,
        audienceId: action.payload.audienceId,
        complexAudienceId: action.payload.complexAudienceId,
        designId: action.payload.designId
      });
    }

    case WIZARD.UPDATE_CAMPAIGN_OLDDESIGN_ID: {
      return Object.assign({}, state, {
        campaignId: action.payload.campaignId,
        oldDesignId: action.payload.oldDesignId
      });
    }

    default:
      return state;
  }
};

export default WizardReducer;
